/**
 * Document selector to select mandatory script.
 */
export const MANDATORY_SCRIPT_SELECTOR = "script[onerror='this.failed=1']";
